define.alias("shared/components/shared/social/instagram-upgrade/banner", "calendar/components/shared/social/instagram-upgrade/banner");